import React from 'react';
import './AssetSummary.css';
import { BeatLoader } from 'react-spinners';

// Import generic components
import Card from '../../../generic_components/Card/Card';

const AssetSummaryCards = ({ data, loading }) => {

  const renderLoader = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
      <BeatLoader size={10} color="#ccc"/>
    </div>
  );
    
  return (
    <div className="dashboard-container">
      <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
        <div className="card-container">          
          {/* <div className="card-icon">🖥️</div> */}
          <div className="card-icon">            
            <i className="fa-solid fa-desktop" style={{color: '#ffffff'}}></i>
          </div>
          <div className="card-info">
              <div className="card-title">Total Assets</div>
              <div className="card-subtitle">Active infrastructure</div>
          </div>
        
          {
            loading ? (                
                renderLoader()                
            ) : (
              <div className="card-count green">{data.total}</div>
            )
          }
        </div>
      </Card>

      <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
        <div className="card-container">
          <div className="card-icon">✅</div>
          <div className="card-info">
            <div className="card-title">Healthy Assets</div>
            <div className="card-subtitle">Operating normally</div>
          </div>
          {
            loading ? (
              renderLoader()
            ) : (
              <div className="card-count blue">{data.healthy}</div>
            )
          }
        </div>
      </Card>

      <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
        <div className="card-container">
          <div className="card-icon">⚠️</div>
          <div className="card-info">
            <div className="card-title">Critical Assets</div>
            <div className="card-subtitle">Require attention</div>
          </div>
          {
            loading ? (
              renderLoader()
            ) : (
              <div className="card-count orange">{data.critical}</div>
            )
          }
        </div>
      </Card>

      <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
        <div className="card-container">
          <div className="card-icon">❌</div>
          <div className="card-info">
            <div className="card-title">Expired Assets</div>
            <div className="card-subtitle">Past lifecycle</div>
          </div>
          {
            loading ? (
              renderLoader()
            ) : (
              <div className="card-count red">{data.expired}</div>
            )
          }
        </div>
      </Card>

    </div>
  );
};

export default AssetSummaryCards;
